import React from 'react';
import { useAuth } from '@/App';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import ProductionEntryPage from '@/pages/ProductionEntryPage';

const ProductionRunsPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const canEdit = user?.role === 'SUPERVISOR' || user?.role === 'OWNER' || user?.role === 'MANAGER';

  return (
    <div className="space-y-6 animate-fade-in" data-testid="production-runs-page">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="font-heading text-3xl font-bold text-slate-900">Production Run Entry</h1>
          <p className="text-slate-500">Create and submit daily production runs.</p>
        </div>
        {canEdit && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/production-runs/history', { state: { status: 'DRAFT' } })}
          >
            View all drafts
          </Button>
        )}
      </div>

      {canEdit ? (
        <ProductionEntryPage
          hideBackButton
          // Standalone ProductionEntryPage usage: onSaved is a no-op because this page has no parent list/state to refresh after saves.
          onSaved={() => {}}
        />
      ) : (
        <Card className="border-slate-200">
          <CardHeader>
            <CardTitle className="text-lg">Production Run Entry</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-slate-500 text-sm">
              You do not have permission to create or edit production runs.
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default ProductionRunsPage;
